import { Image } from '@app/components'
import React from 'react'

export const MastercardIcon = ({ style }: { style?: React.CSSProperties }) => {
  return <Image preview={false} src="../images/mastercard.png" style={style} />
}
